// frontend/src/api/config.js

// In dev you can set REACT_APP_API_URL=http://localhost:3000
// In prod we hit the same origin by default
export const API_BASE_URL =
  process.env.REACT_APP_API_URL?.replace(/\/$/, '') || '/'

  /**
 * Decode the JWT payload and extract the store_hash or sub claim.
 */
function parseStoreHash(token) {
  try {
    const parts = token.split('.');
    // JWT format: header.payload.signature
    if (parts.length === 3) {
      const payload = JSON.parse(atob(parts[1]));
      return payload.store_hash || payload.sub?.split('/').pop();
    }

    // Legacy signed_payload: base64(payload).signature
    const payload = JSON.parse(atob(parts[0]));
    return payload.store_hash || payload.context?.split('/').pop();
  } catch (e) {
    console.error('Failed to parse token', e);
    return null;
  }
}

/**
 * Get the store hash from the query string or from the JWT payload.
 */
export function getStoreHash() {
  const params = new URLSearchParams(window.location.search);
  const urlHash = params.get('store_hash');
  if (urlHash) return urlHash;

  const token = getAuthToken();
  return token ? parseStoreHash(token) : null;
}


/**
 * Read the BigCommerce JWT from the URL once (either signed_payload_jwt or signed_payload),
 * stash it in localStorage, then return it on every call.
 */
export function getAuthToken() {
  const params = new URLSearchParams(window.location.search)
  // Try both variants
  const urlToken =
    params.get('signed_payload_jwt') ||
    params.get('signed_payload')

  if (urlToken) {
    localStorage.setItem('SIGNED_PAYLOAD', urlToken)
    // Clean up the URL so future reloads don't re-parse
    window.history.replaceState({}, '', window.location.pathname)
  }

  return urlToken || localStorage.getItem('SIGNED_PAYLOAD')
}

/**
 * Build an Authorization header if we have a JWT.
 */
export function getAuthHeaders() {
  const token = getAuthToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}








